import { render, staticRenderFns } from "./headerMoreItem.vue?vue&type=template&id=60a4978e&"
import script from "./headerMoreItem.vue?vue&type=script&lang=js&"
export * from "./headerMoreItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports